export default [
  {
    id: 0,
    title: "某变电工程三维建模项目",
    Releasepeople: "武汉大学计算机视觉研究中心",
    url: "https://dl.dpgrid.com/www/imgs/banner-17.jpg",
    keyword: "",
    time: "2022-01-03",
    introduce: "",
    content: [
      {
        title: "项目介绍",
        content:
          "麻阳苗族自治县为湖南省怀化市辖县，位于湖南省西部。麻阳境内南北西三面群山屏列、地势较高。海拔最高1405米，最低130米，以丘陵为主。本项目是基于三维模型上进行电力设计，对比以往二维矢量地图有本质的区别。首先更加直观呈现设计效果；其次，三维实景能更好贴合实际地形，更好预判。 采用无人机低空倾斜摄影测量方式，可实现高效率作业、降低项目成本和作业安全风险，成果更直观，精度更高，时效性更强。",
        Image: ["https://dl.dpgrid.com/www/imgs/process2.0.png"]
      },
      {
        title: "技术路线",
        content:
          "外业采用多旋翼无人机进行航飞数据采集，使用企业级三维建模软件进行空三加密及建模，随后进行修饰，得到三维实景模型。",
        Image: ["https://dl.dpgrid.com/www/imgs/process2.1.png"]
      },
      {
        title: "项目成果",
        content: "",
        Image: ["https://dl.dpgrid.com/www/imgs/process2.2.png"]
      }
    ]
  },
  {
    id: 1,
    title: "旅游工程三维建模项目",
    Releasepeople: "武汉大学计算机视觉研究中心",
    url: "https://dl.dpgrid.com/www/imgs/banner-19.jpg",
    keyword: "",
    content: "",
    time: "2022-01-01",
    introduce: "",
    content: [
      {
        title: "项目介绍",
        content:
          "测区位于内蒙古自治区中西部，平均海拔 1080 米，按甲方提供的范围线，共计面积 30平方公里，是高精度地形图及大面积三维建模项目。测区地形复杂、 房屋众多， 有许多明显的不规则测区， 测区海拔最高落差达30 米， 是航测案例中较为复杂的实施项目。 ",
        Image: ["https://dl.dpgrid.com/www/imgs/process2.3.png"]
      },
      {
        title: "技术路线",
        content:
          "根据甲方需求，采取无人机进行低空倾斜摄影测量的方式采集测区影像、POS 等数据，通过数据处理生产获得 1:500 比例尺精度的 DOM、DEM、DLG 以及三维模型成果。外业像控测量使用 RTK 进行，详细技术要求按照《低空数字航空摄影外业规范》执行。",
        Image: [
          "https://dl.dpgrid.com/www/imgs/process2.4.png",
          "https://dl.dpgrid.com/www/imgs/process2.5.png"
        ]
      },
      {
        title: "项目成果",
        content: "",
        Image: [
          "https://dl.dpgrid.com/www/imgs/process2.7.png",
          "https://dl.dpgrid.com/www/imgs/process2.8.png"
        ]
      }
    ]
  },
  {
    id: 2,
    title: "航空摄影测量的应用",
    Releasepeople: "武汉大学计算机视觉研究中心",
    url: "https://dl.dpgrid.com/www/imgs/banner-15.jpg",
    keyword: "",
    content: "",
    time: "2022-01-01",
    introduce: "",
    content: [
      {
        title: "测量地形概况",
        content:
          "测量山区地形时，如果地形区域内天气条件恶劣，阴雨多雾，测量地形的面积和最终测绘规模都比较大。航空摄影测量是必要的，测量该地的地形，以方便实际应用和了解该地区的地形。航空摄影测量系统是利用航空摄影测量技术测量地形的先进技术，是一种国外引进的高像素数码航空摄影设备。在进行该地区的地形测量时，数字航测、卫星定位和导航系统自动控制操作，协助空中摄影测量。该地区地形测量的要求是保证地物的精度、拍摄和测量结果的准确性，确保测量的质量。",
        Image: []
      },
      {
        title: "航空摄像测量中像片的控制测量",
        content:
          "该地区的地形特征的测量航空摄影测量，主要是结合导航和定位信息的GPS导航系统和拍摄期间拍摄的数据，航拍图像和地面测量反映的真实特征和地形的地面，并进行测绘。在航空摄影测量过程中，通过对摄影控制点的设置和分布，通过与全球定位导航系统相关的测量技术测量图像控制点的面积和测量地形，对于在测量图像控制点时，应注意外部控制点的定位。总的来说，图像控制点的外部控制点应设置在地形、道路或斑马线的拐角处，具有明显的特点和参考价值，在测量过程中，应注意控制点的位置，绘制记录，便于后期其他工作的开展。",
        Image: ["https://dl.dpgrid.com/www/imgs/process2.9.png"]
      },
      {
        title: "航空摄像测量中空中三角测量",
        content:
          "在航空摄影测量过程中，航空摄影测量中的空中三角测量主要采用航空数码摄像设备进行地形测量，航空摄影数字图像的自动设定不需要人工操作，通过系统设置进行自动计算和生成。在航空摄影测量地形时，必须完成手动选择的连接点的相对取向，以及测量模型和天线连接测量之间的连接等。然后，通过对航空摄影测量中的连接点和图像控制点位置的调试，实现了航空摄影测量的标度映射，实现了对地形的精确测量。",
        Image: []
      },
      {
        title: "航空摄像测量中外业补测操作",
        content:
          "经过上述测量操作，有必要对航测航测地形图中的立体信息进行测绘和编辑。正常情况下，航空摄影地形测量的使用，为获得内部和编辑操作，使用GEOWAY和JX4软件实现。在航测地形测量中，应准确采集目标的线性地形结构和线节点，以提高采集信息的准确性。但对于一些地形等高线和水平线要用手工绘进行采集在地形区建筑在室内信息采集中，应采用航拍照片，对建筑物的屋顶边缘进行切割，以测量建筑物的地形面积，房屋测量的正确的结果必须由自动直角进行改正。此外，在航空摄影的地形测量应采取收集测量的其他对象，例如，应当注意对于地形结构区域内的其它类似于电杆等物体的测量采集，为了避免航空摄影内业编辑或反复试验后故障测量带来的麻烦，对于航空摄影不能测量的部分，必须进行对外测量采集，以保证地形特征测量的完整性。",
        Image: []
      },
      {
        title: "航空摄像测量中外业补测操作",
        content:
          "在对该地区的地形特点测量航空摄影技术的使用，对死角没有地形结构的地形测量或隐蔽的位置利用空气摄像测量技术，通常进行外业补测工作。在进行外业补测操作中，为了达到航空摄影测量的精度，通常将测量结果与测绘结果进行比较。通过比较结果，纠正测量误差，或者当该地区的地形相对隐蔽，或在一定程度上难以测量面积和建筑物的进行附加测试，并与结果进行比较，如果发现测量误差，要改正，以保证测量结果的准确性。",
        Image: []
      }
    ]
  },
  {
    id: 3,
    title: "贴近摄影测量｜精准监测房屋施工的每一个环节",
    url: "https://dl.dpgrid.com/www/imgs/banner-13.jpg",
    Releasepeople: "武汉大学计算机视觉研究中心",
    keyword: "三维模型，贴近摄影测量 ",
    content: "",
    time: "2021-12-06",
    introduce:
      "建筑业正处于技术改造的边缘。尽管建筑行业通常很难采用新技术，但物联网设备和其他尖端技术在建筑公司中越来越受青睐。测绘无人机处于这种技术采用趋势的最前沿。在考虑技术领先行业时，建筑可能不是第一个想到的部门。这也是有原因的，因为该行业在其大部分历史上一直保持着相对较低的技术水平。随着新技术带来更多实质性收益，该趋势开始发生逆转，并且建筑行业对中断的需求变得更加明显。众所周知，建设工程项目通常缓慢且昂贵。麦肯锡经常引用的一项研究表明，大型项目通常超出预算80％，完成时间比计划的时间长20％。诸如测绘无人机之类的技术可以改变这一点。",
    content: [
      {
        title: "测绘无人机在施工前的应用",
        content:
          "如今，我们发现无人机以多种不同方式进入建筑行业。从规划和设计开始，勘测无人机可为建设项目的每个阶段提供改进。在公司开始建造任何东西之前，他们需要调查潜在的工作场所。传统上，工人必须走遍现场并手动进行测量和记录，但这效率低下。无人机为勘测现场提供了更快的选择。如今的无人机可以在空中停留长达90分钟，并且在这段时间内所覆盖的地面范围比行人在数小时内所能覆盖的范围要大得多。当他们在有问题的物业上空飞行时，他们可以收集各种数据类型供施工团队使用。您遇到的大多数无人机都可能捕获照片或视频，但是它们可以做的更多。更高级的相机和传感器可以进行地理空间测量和温度读数，并创建3D数字模型。这些为施工人员提供了对工作现场的深入、准确的了解，并通知了任何必要的设计或工作流程更改。<地形图>建筑师甚至可以在设计建筑物之前使用勘测无人机。无人机提供的多种角度和数据范围可以帮助他们创建最安全、最容易实现的设计。另外，这些信息可能表明潜在的站点不适合给定的项目，以便团队可以寻找新的位置。",
        Image: ["https://dl.dpgrid.com/www/imgs/process3.1.png"]
      },
      {
        title: "在施工阶段的应用",
        content:
          "这些技术一旦开始为建筑公司提供服务，便继续为他们提供价值。施工现场可能是危险的，并且该行业是任何行业中工人受伤率最高的行业之一。无人机可以帮助预防这些事故。工人可以使用无人机检查工作场所的某些部分是否存在危险， 以免将自己置于危险之中。 这些航拍技术具有几乎无限的运动范围， 使员工可以从各个角度观察事物， 并亲自发现可能错过的事物。通过在安全距离内或者3D模型检查危险， 施工人员可以防止事故发生， 因为这可能会增加成本并导致延误。 测绘无人机还可以帮助项目的各个利益相关者监控其进度。站点管理员可以将无人机镜头与计划和蓝图进行比较，以确保没有错误。由于返工占所有建筑工作的30％，因此防止错误可以节省大量时间。建设项目涉及许多利益相关者，他们可能必须先进行工作验证，然后才能进行下一步。无人机是一种快速、准确的方法，可为他们提供工作场所更新，因此他们可以毫不延迟地进行操作。因此，整个项目的完成时间将缩短。客户通常希望定期更新其项目，包括图片。传统上，建筑公司必须租用直升机拍摄航拍照片或视频，这可能很昂贵。无人机让团队以更低的成本提供相同的更新。",
        Image: []
      },
      {
        title: "施工后阶段的无人机调查",
        content:
          "当施工团队完成施工阶段时，无人机将继续为项目相关人员提供帮助。施工结束后，对财产的责任将转移给所有者或经理。这种过渡需要大量文档和仔细检查，而无人机可以帮助使操作更顺畅。在施工阶段，来自无人机的详细图像和视频可以向业主显示该项目已经按照预期进行了。与书面声明相比，视频和照片提供了更具体的真相来源，使所有者更加满意。这种信任也将有助于加快过渡过程，使客户可以更快地接管其财产。一旦控制了财产，所有者和管理者就可以使用无人机进行日常维护。检查建筑物的某些部分可能具有挑战性，而某些地方，例如高处的部分，亲自检查可能很危险。无人驾驶飞机可以轻松，安全地到达任何建筑地点，使业主可以全面了解维护需求。如果建筑物所有者决定要添加到建筑物中，则可以先使用无人机来调查该区域。这些调查的数据可以揭示它们是否可以扩展以及如何最好地扩展。使用无人机进行这些检查而不是手动进行将节省大量时间和金钱。",
        Image: []
      }
    ]
  },
  {
    id: 4,
    title: "武汉大学张祖勋院士获评“荆楚好老师”特别奖",
    url: "https://dl.dpgrid.com/www/imgs/software4.jpg",
    Releasepeople: "武汉大学计算机视觉研究中心",
    keyword: "",
    content: "",
    time: "2021-09-15",
    introduce: "",
    content: [
      {
        title: "",
        content:
          "9月8日下午，在第37个教师节到来之际，2021“寻访荆楚好老师”评选结果揭晓。中国工程院院士、武汉大学遥感信息工程学院教授张祖勋获评“荆楚好老师”特别奖。",
        Image: ["https://dl.dpgrid.com/www/imgs/Content-img1.png"]
      },
      {
        title: "【颁奖词】",
        content:
          "经天纬地丈山河，耄耋之年系讲台。科研报国一甲子，初心不改大先生。他测的是一个个山川坐标，绘的是一个个学子未来。扎根祖国育桃李，蓬勃的测绘事业就是他最闪亮的勋章。不愧为国之栋梁，无负于师之使命。8月的一天，中国工程院院士、武汉大学遥感信息工程学院教授张祖勋冒雨来到办公室，为新学期的《测绘学概论》修订讲稿、更新课件。25年来，这是他每年暑假雷打不动的一项工作。今年，他还参与了该课程慕课录制。从教61年84岁的张祖勋仍活跃在科研与教坛一线。他比学生更“爱玩”，带着研究生用无人机丈量山河大地、踏访重庆箭穿洞勘测危岩体、共同编写程序代码……耄耋之年，荣誉等身。张祖勋院士却说：“平凡是人生的永恒。”",
        Image: ["https://dl.dpgrid.com/www/imgs/Content-img1.1.png"]
      },
      {
        title: "科技攻关打破国外垄断",
        content:
          "专研摄影测量一辈子，张祖勋执着于摄影测量与遥感领域研究。从数百米的高空到光年外的太空， 他用科技丈量着每一寸土地。 在金沙江白格滑坡， 他监测高山峡谷区的每一道裂缝， 有效进行地质灾害预警； 在汶川地震发生后， 他率领团队用最新技术制作出震区首个数字地面模型， 为抗震救灾部署起到至关重要的作用； 在陡直的峭壁间， 山西悬空寺岌岌可危， 他力争还原古建筑细节， 为文物保护出谋划策……“ 1955 年刚进同济大学测量系， 我还不知道测量是什么。” 张祖勋回忆， 进校参观仪器设备时， 透过一面立体反光镜， 两张照片在他眼前变成了高低起伏的三维立体山脉。 这一幕让张祖勋认准了要学航空摄影测量专业， 他成了新中国成立后培养的第一批测绘高材生。“ 你们中国人连我们仪器上的一颗螺丝钉也造不出！” 1976 年， 张祖勋赴瑞士最先进的航测仪器厂学习， 被瑞士技术人员的这句话刺痛。 他下定决心， 要让中国的测绘遥感技术在国际上有立足之地。1978 年， 我国航空摄影测量和遥感学科的主要奠基人王之卓， 提出全数字化摄影测量观点。“ 那个年代， 存储一张照片至少要128MB的空间， 而计算机内存只有64KB， 完全不成比例。” 作为王之卓院士的得力学生， 他顶住质疑， 从零开始， 带团队埋头苦干14年。“ 当时肩扛手提仪器搞测量， 就像小米加步枪。” 张祖勋说， 数据输入靠穿孔纸带， 人工逐点读数、 记录、 穿孔…… 过程繁琐。 抓住计算机迅猛发展的东风， 1992 年， 他带领团队推出中国首个可产业化的全数字化自动测图系统软件VirtuoZo。 这项开创性成果使中国摄影测量跻身国际三强。 1993 年， 张祖勋获国家自然科学二等奖。 后来， 他首创性地提出数字摄影测量网格思想， 研制出我国首套完全自主知识产权的航空航天遥感影像数字摄影测量网格处理系统DPGrid， 彻底打破了国际软件的垄断地位。 2019 年， 他再次提出第三种摄影方式—— 贴近摄影测量。 如今， 张祖勋的科研成果产生经济效益逾亿元， 用于无人机测绘更是创利20多亿元。 ",
        Image: ["https://dl.dpgrid.com/www/imgs/Content-img1.2.png"]
      },
      {
        title: "年过八旬仍带学生野外实验",
        content:
          "武汉大学6位院士联手打造的《测绘学概论》，被冠以“最奢侈基础课”之名。张祖勋负责的一堂课有90分钟，他一讲就是25年，每次都坚持站着讲完。“ 听张老师讲《 测绘学概论》 时我很意外， 没想到一个院士讲课这么通俗易懂。” 武汉大学2020级本科生丁怡彤回忆， 张院士讲到一些案例时常会问：“ 好玩吧？” 提到好玩， 学生们都打起了精神。 张祖勋始终认为， 教书育人， 兴趣是最好的老师。 从悉尼歌剧院到西藏布达拉宫， 他的课件里除了理论公式， 还容纳了世界各地的美景。“ 摄影加上测量多好玩， 把照片处理成三维图像， 就像艺术品一样。” 经他一指点， 学生们兴趣大增。 2019 年， 年过八旬的张祖勋亲自带研究生踏访重庆巫山箭穿洞， 进行危岩勘测。 当地危岩体存在滑落的可能性， 潜在威胁着长江航道安全。“ 那里地势险要， 张院士和我们坐在一条船上， 指挥大家起飞无人机， 对地貌进行三维建模。” 武汉大学博士生席可说，“ 工程为先” 是张院士团队的一贯风格， 他始终强调“ 把论文写在祖国大地上”， 重视科研的应用价值。2020年暑期，席可在巫山进行野外实验时，无人机突发意外，被挂在距离地面几百米高空的树枝上。张祖勋不但马上为学生调派新的设备，还安慰他们：“科研路上难免有挫折，最重要的是坚持做完。”张祖勋至今仍每周召集研究生开组会。“张院士会参与我们的科研过程。就在6月，他还亲自帮我修改了一个程序的源代码，给出针对性指导。”今年从学院本科毕业后，赵新博如愿成为张祖勋团队的硕士生。张祖勋也常常讲起自己学生时代的故事。一次，因为没有及时推进科研任务，从不发脾气的王之卓院士语重心长地对他说：“人不怕慢，就怕站。”这句话始终勉励着张祖勋不断攻坚克难，也成了此后张祖勋每一届学生都耳熟能详的话。 ",
        Image: ["https://dl.dpgrid.com/www/imgs/Content-img1.3.png"]
      },
      {
        title: "不拘一格提携后辈锻造人才",
        content:
          "“要善于发现年轻人的才能，创造平台让他们施展特长。”张祖勋一向擅于发掘学生潜能，乐于不拘一格提携后辈，61年来源源不断地为社会各领域输送人才。如澳大利亚联邦科学与工业研究组织最高科学奖获得者吴晓良教授、中国青年科技奖获得者张力等杰出学者；也有四维图新公司创始人孙玉国等知名企业家。武汉大学科学与技术发展研究院院长柯涛， 曾跟随张祖勋攻读博士学位。 期间， 张祖勋留意到柯涛有着很强的组织协调能力。 毕业后， 柯涛留校任讲师， 张祖勋便放心地把一个国防型号项目交给他。“ 他是很温和的老师， 但对科学问题非常严谨。” 柯涛回想起唯一一次被批评的经历，“ 张院士用一本书给我模拟讲解一张影像， 讲了三遍， 我仍然固执己见。 他便重重地把书放在桌上。” 事后， 张祖勋又主动打来电话讲授， 直到柯涛真正理解。 徐轩成为高级工程师后， 总也忘不了张祖勋的提携。 30 多年前， 徐轩就精通维修各类国外先进设备。 学校选派系主任赴欧洲学习考察， 张祖勋说：“ 工科领域不仅要有好的教授， 也要有优秀的技术人员。” 他毫不犹豫地把机会给了还是普通技术人员的徐轩。“ 平凡是人生的永恒”， 这是张祖勋曾写在柯涛笔记本上的一句话。 柯涛感慨：“ 跟着张院士从事科学研究16年来， 我最大的收获是学习到他身上的科学家精神。 张院士几十年如一日不断挑战前沿， 我想正是这种平凡和低调的人生观， 才能使科技创新成为永恒。” ",
        Image: ["https://dl.dpgrid.com/www/imgs/Content-img1.4.png"]
      },
      {
        title: "捐资百万设立“教书育人奖”",
        content:
          "“我其实很愧疚，相比做科研的时间，给本科生上课还是太少了。”张祖勋说。为了让大学回归教育的本质， 2017 年， 张祖勋向武汉大学遥感信息工程学院捐赠100万元， 倡议设立“ 教书育人奖”， 鼓励在教学一线辛勤耕耘， 深受学生爱戴的优秀教师。 为了保证“ 教书育人奖” 的可持续性， 张祖勋联络社会各界资源， 动员企业和校友赞助。 他的学生孙玉国主动请缨：“ 以后我把这个奖包下来！” 遥感信息工程学院院长张永军透露， 曾有人建议张院士以自己的名字命名“ 教书育人奖”， 却被他婉拒。“ 我从大一时上《 测绘学概论》 接触到张院士， 研究生阶段也听过他的课。 现在自己成为学院教师， 总能看到他办公的身影， 和蔼地与师生交往。 张院士严谨治学， 热爱教育的精神令人倾佩。” 如今已是学院副教授的桂志鹏， 曾两次获得“ 教书育人奖”。 张祖勋从王之卓院士手里接过接力棒， 如今又传到了他的学生张永军手里。 他说：“ 还是学生时， 张院士常用王之卓先生的‘ 不怕慢， 就怕站’ 来激励我。 从教后， 我也坚持把这种不畏挫折， 勇攀高峰的科学家思想传递下去。”“ 荧荧红烛， 巍巍师魂， 身立杏坛， 首修人品……” 每届“ 教书育人奖” 颁奖典礼上， 教师们齐诵《 师德铭》 的场面十分动人。 一片冰心， 赓续遥感学科薪火； 两鬓霜华， 铸就师德丰碑。 看着一代代学生羽翼渐丰， 成为社会各界的中流砥柱， 这是张祖勋毕生最大的幸福。 ",
        Image: ["https://dl.dpgrid.com/www/imgs/Content-img1.5.png"]
      }
    ]
  },
  // {
  //   id: 5,
  //   title: '张祖勋：科研报国守初心，薪火相传育英才',
  //   Releasepeople: '武汉大学计算机视觉研究中心',
  //   keyword: '',
  //   content: '',
  //   time: '2021-09-08',
  //   introduce: '',
  //   content: {
  //     list: [{
  //       title: '',
  //       content: '',
  //       Image: []
  //     }, ],
  //   }
  // },
  {
    id: 6,
    title: "贴近摄影测量由来与含义张祖勋院士",
    url: "https://dl.dpgrid.com/www/imgs/banner-13.jpg",
    Releasepeople: "武汉大学计算机视觉研究中心",
    keyword: "",
    content: "",
    time: "2020-06-11",
    introduce: "",
    content: [
      {
        title: "",
        content: "",
        Image: []
      }
    ]
  },
  {
    id: 7,
    title: "张祖勋院士：聊聊“重建”悬空寺的故事",
    url: "https://dl.dpgrid.com/www/imgs/banner-17.jpg",
    Releasepeople: "",
    keyword: "",
    content: "",
    time: "2019-11-19",
    introduce: "",
    content: [
      {
        title: "数字摄影测量网格（DPGrid）脱颖而出",
        content:
          "尽管已经年逾八旬，但中国工程院院士、国际欧亚科学院院士，著名摄影测量与遥感学家张祖勋从未停止对科技难题的钻研，不仅亲自参与科研项目，也坚持为学生授课。今年年初张祖勋院士提出的贴近摄影测量震动业界，被称为区别于竖直航空摄影测量、倾斜摄影测量的第三种摄影测量方式。近日张祖勋院士接受了泰伯网专访，谈起工作和生活中的趣事，张院士风趣幽默，而对于产业发展及科研落地，他则持相当严谨的态度。",
        Image: ["https://dl.dpgrid.com/www/imgs/Content-img1.6.png"]
      },
      {
        title: "“济南女婿”回家",
        content:
          "“我虽然是江苏人，但也是半个山东人。我们家的另外一位张老师，她是1955年从济南到了同济（大学），我是从苏州到了同济（大学），就这样，我拥有了一份济南情怀。”张祖勋院士家的“另一位张老师”，指的是他的妻子，武汉大学遥感信息工程学院张世兴教授。“ 第一次到济南是1963年， 给我留下了深刻的印象： 风景秀丽、 人杰地灵， 可惜当时条件有限， 没有留下很好的照片。 2016 年的春节我是在济南过的， 在五龙潭后铜元局后街附近， 有位男士在小河里洗衣服， 刚好被我记录了下来。 这个场景还是我小时候在苏州河边住的时候经常看到的。 第一个感想是， 以前听到传言说北方男人有些大男子主义， 但我看到的济南男士竟如此勤劳； 第二个感想是， 现在大城市里面， 还能有如此清澈的水， 应该是并不多见的； 第三个感想是， 云计算、 大数据、 智能化时代， 有了人工智能， 机器智能了， 人变傻了就麻烦了， 人还是要做很多小事， 对我们的健康会更有利。” 11 月9日， 张祖勋院士工作站在济南正式揭牌， 这也是山东省航测遥感领域的首家院士工作站。 揭牌仪式上， 自称为“ 半个山东人” 的他谈起这份对济南的独特情感。 张院士曾多次到山东就地理信息进行交流， 而本次建立的工作站将致力于地理信息产业技术创新、 成果转化， 为山东省国土空间规划、 智慧城市建设、 工业互联网等提供基础数据支撑和高精度位置服务。在现场， 张祖勋院士介绍了“ 云控与贴近摄影测量” 的相关情况。贴近摄影测量被称为区别于竖直航空摄影测量、 倾斜摄影测量的第三种摄影测量方式， 它利用旋翼无人机贴近物体表面摄影， 获取（ 亚厘米级） 高清影像， 并进行摄影测量处理， 从而恢复被摄对象的精确坐标和精细形状结构。张祖勋院士最初提出“ 贴近摄影测量” 这一概念， 是因为看到地质调查人员在悬崖峭壁上像“ 蜘蛛人” 一样作业的危险场景。 他发现， 尽管应用领域不断拓展， 但在地质灾害监测预警领域， 无论是单相机的竖直摄影还是五相机的倾斜摄影测量， 在“ 岩崩、 滑坡” 等地质治理工作中都只能作为一种辅助手段， 还是不得不靠人工冒着生命危险去采集数据。 ",
        Image: []
      },
      {
        title: "贴近摄影测量”应运而生",
        content:
          "这一名词参考了直升机的“贴地飞行”，由已有的对“地”观测演变为对“面”观测，是一种更为精细的观测方式。自年初提出起，张院士团队利用该技术进行了包括古建筑精细化重建、地质灾害调查精细化摄影测量等应用实验，获取了多方面宝贵的案例经验。以巫山箭穿洞为例，张院士团队利用贴近摄影测量获取数据，生成了剖面正交影像图。由于箭穿洞危岩接近垂直，传统正射影像上压缩很大，难以辨识，对于地质调查几乎没有价值，而在正交影像图上则可清晰识别岩体及裂缝，高精度重塑地质地貌。据张祖勋院士介绍，“贴近”并不意味着在运用这项技术时，所有情况下都要与物体表面贴得很“近”。一般来说，无人机“贴近”的距离在5-50米左右，但在调查范围较大，比如对整个三峡库区做整体的滑坡调查时，影像必然是大尺度的，飞行距离可能达到150-200米。张院士也强调，贴近摄影测量这一概念诞生还不足一年，对于新技术应该持谨慎态度，现阶段仍需各方合作，多加验证。",
        Image: ["https://dl.dpgrid.com/www/imgs/Content-img1.7.png"]
      },
      {
        title: "“重建”悬空寺背后的故事",
        content:
          "上半年，张院士团队因“重建”悬空寺而屡屡刷屏，这也是贴近摄影测量的典型案例之一。悬空寺，建成于公元491年，位于山西省大同市浑源县恒山金龙峡西侧翠屏峰峭壁间，整座寺院就像悬挂在悬崖上，是佛、道、儒三教合一的独特寺庙。网络中对悬空寺的描述为“半插飞梁为基，巧借岩石暗托，梁柱上下一体，建筑极具特色”，但也正因如此，悬空寺的数据获取及文物保护工作有相当高的难度，2010年，悬空寺入选《时代周刊》世界岌岌可危十大建筑。张祖勋院士向泰伯网谈起“重建”悬空寺背后的故事。张祖勋院士表示， 悬空寺“ 重建” 之所以引发媒体争相报道， 原因有二， 一是借助无人机利用贴近摄影测量技术拍摄悬空寺， 对其建成高精度实景三维模型具有典型意义， 二是巴黎圣母院失火引发了舆论对文物保护话题的关注。但其实要用无人机为悬空寺进行“重建”，前期还需要大量的联系和沟通工作。张院士团队开具介绍信，辗转联系到各级相关部门（包括当地的自然资源部门、文物保护单位、景区管理单位等），才获准对悬空寺进行拍摄。悬空寺身处山谷中间，山谷间吹来的“穿堂风”达到六级，谷底GPS信号也不太好。从早上9点进入景区开始准备数据采集工作，直至下午五六点钟才飞完，最终成功“重建”数字悬空寺。鲜为人知的是，当时张院士团队还对山西省另一重点保护文物应县木塔（又名“释迦塔”）进行了数据采集和高精度实景三维建模，而这背后还有一段小插曲。位于山西应县城内的应县木塔是目前世界上现存最高、最古老的纯木结构建筑。这座木塔建于九百多年前的辽代，通体没用一颗铁钉，全部架构均由卯榫咬合而成，千年承重数千吨而不下沉，被称为建筑界的奇迹。正因如此，应县木塔与埃菲尔铁塔、意大利比萨斜塔和埃及金字塔齐名，每年希望对应县木塔进行学术研究的团队非常多。在确定应县木塔管理责任时，张院士团队就颇费了一番工夫：从自然资源部门问到文物保护部门，最终才找到山西省应县木塔文物管理所。在团队到达时，主管部门却并未第一时间同意对该塔进行数据采集的申请。对方查看了介绍信，又反复确认了张祖勋院士拍摄应县木塔的方式、目的和团队并补签协议后，才同意进行数据采集。虽然过程很曲折，但好在当天天气条件比较好，最终，团队于当日三点多完成了对应县木塔的数据采集，为其建立了高精度实景三维模型。 张院士感叹，“做事情其实不是那么容易”，真正将摄影测量和三维建模技术运用到文物保护当中，还需要技术团队和文物主管部门多方交流与磨合，大范围推广还需要比较长的时间。",
        Image: [
          "https://dl.dpgrid.com/www/imgs/Content-img1.8.png",
          "https://dl.dpgrid.com/www/imgs/Content-img1.9.png"
        ]
      },
      {
        title: "得数据者得天下",
        content: `张祖勋院士强调，摄影测量必须要有“云控”。事实上，“云控”与“贴近”是两个概念，前者是有关摄影测量的控制，后者是有关摄影测量的数据获取。“无控” 一直是摄影测量追求的目标， 而在大数据与智能化的今天， 云控制开拓了“ 无控” 的新思路。 之前外业要测点， 内业要转点， 工作流程非常复杂。 通过云控制， 摄影测量可以简化以往复杂的工作流程， 提高工作效率。 特别是“ LiDAR点云” 可以作为摄影测量的“ 控制”， 有可能成为“ 城市的控制框架”。张院士介绍，“ 控制场” 其实是一个新的概念， 但其实在智慧城市建设过程中， 大家多多少少都用到了， 只是有些人是主动用， 有些人是被动用。 传统的CORS站网需要一级一级的控制， 但点云本身已经提供了一套具有一定精度的平面和高程控制， 控制场只需要通过点云控制即可。 之前用点云做三维重建， 现在要用点云做控制网。 无论是先飞的还是后飞的， 无论是谁飞的， 只要把点云数据拿过来就可以做成果， 而且不需进行大量的控制工作。 在大数据时代，“ 云控” 的前景可能更为广阔。 张院士表示， 必须转变传统观念， 要看到随着时代发展， 云控制、 集群控制的重要作用， 在新一代信息技术的基础上转变传统测绘地理信息获取的工作模式。 地理信息产业正在转向高质量发展阶段，在张祖勋院士看来，高质量发展必须要重视科技的前沿发展。2000年之后，尤其是最近几年，地信产业发展非常迅速，天空地一体化的发展速度是之前难以想象的。最最重要的一点是，老百姓能够看得见地理信息的应用方向，这其实不是地信产业自身发展的结果，而是地理信息与其他科技相结合的产物。比如，现在大家都会用手机GPS定位，用手机地图导航，大家都意识到了空间信息的作用，这也是社会需求发展的产物。与此同时， 地信企业也受到来自新一代信息技术的冲击。 不过张祖勋院士认为， 有竞争其实是好事， 竞争能够促进发展， 激发创造力。 张院士表示， 现在科技前沿技术发展的确很快， 但地信企业在面对挑战时， 也要对自己有信心， 积极迎接挑战， 无需盲目悲观。 测绘地信不光是现有能看到的技术， 根据需求还产生了很多新的发展方向。 高质量发展必须要依靠技术优势， 需要不断提高科技含量， 如果只依靠低价比拼， 地信产业无法形成良性竞争态势。 张祖勋院士引用中国工程院院士陈鲸的表述：“ 大数据面临的挑战复杂艰巨， 未来信息世界是 '三分技术、七分数据'，得数据者得天下。” 科技发展到了今天， 数据本身就是资源， 一般来说地信产业数据生产出来都是给别人用的， 但业内人士此前往往没想到数据可以自己利用， 网络上的数据有很多都没有利用起来。 数据本身就是生产力， 这一点必须要重视。有句话叫“ 隔行如隔山”， 如何打破地信企业与其他企业之间的壁垒是个关键问题。 张祖勋院士认为， 技术交流是个很好的形式， 借助交流会等平台， 促进企业之间的互动， 有助于解决这一问题。 此外也要注意宣传普及， 尤其是对数据应用拓展、 一体化平台服务等方面， 信息时代要借助网络力量进行宣传拓展， 利用现代手段将不同行业间的距离缩短。 `,
        Image: ["https://dl.dpgrid.com/www/imgs/Content-img2.0.png"]
      }
    ]
  },
  {
    id: 8,
    title: "航空航天遥感影像摄影测量网格处理关键技术",
    url: "https://dl.dpgrid.com/www/imgs/banner-15.jpg",
    Releasepeople: "武汉大学计算机视觉研究中心",
    keyword: "",
    content: "",
    time: "2010-03-08",
    introduce: "",
    content: [
      {
        title: "",
        content: `支撑项目（平台）：武汉大学数字摄影测量与计算机视觉研究中心
                    参与单位：武汉大学
                    所属学科：测绘科学与技术
                    主要贡献者：张祖勋
                    成就简介：首次提出数字摄影测量网格的创新思想，建立了完整的遥感影像智能摄影测量处理技术体系，是我国测绘遥感领域首个实现核心技术出口的自主知识产权软件研发成果，在多项重大工程项目和灾害应急响应中发挥了重要作用。`,
        Image: []
      },
      {
        title: "",
        content:
          "航空航天遥感在大范围空间信息快速获取、应对重大自然灾害及国家安全等方面具有重要作用，但是，其海量观测数据对处理技术提出了巨大挑战，尤其是应急响应情况下时效性要求很高。传统摄影测量受理论和技术制约采用单人单机交互式生产模式，根本无法满足地球空间信息产业、国家重大工程、突发事件应急响应等领域对高精度快速处理能力的迫切需求。",
        Image: []
      },
      {
        title: "",
        content:
          "因此，获得2017年国家科技进步二等奖的“航空航天遥感影像摄影测量网格处理关键技术与应用”项目，首创性地提出了数字摄影测量网格处理的创新思想，解决了我国航空航天遥感影像高精度自动化准实时处理的科学问题。",
        Image: []
      },
      {
        title: "",
        content:
          "项目成果突破了高可靠性影像匹配、中低空影像一键式智能处理、多源国产卫星影像协同处理及大范围地理信息产品准实时生产等基础理论和关键技术，建立了完整的航空航天遥感影像智能摄影测量处理技术体系。相关成果曾获得2015年测绘科技进步特等奖，获得授权国家发明专利23项、软件著作权35项，发表SCI论文45篇。核心技术被ISPRS、JPRS、PERS等国际权威期刊文章评价为“全新的方法”、“非常重要”。",
        Image: []
      },
      {
        title: "",
        content:
          "由多位院士专家组成的鉴定委员会一致认为“摄影测量网格并行处理、高可靠性影像匹配、无人机影像全自动处理、稀疏控制智能空中三角测量、数字影像准实时拼接等核心技术居国际领先水平”。以核心技术为基础，研制出我国首套完全自主知识产权的航空航天遥感影像数字摄影测量网格处理系统（DPGrid），彻底打破了国际软件的垄断地位。软件系统已被国内150多家测绘等领域相关单位广泛应用于多项国家重大工程项目、高校人才培养及各类地理信息产品生产，并在汶川特大地震等突发灾害应急响应方面发挥了巨大作用，取得了显著的经济效益和巨大的社会效益。该项目核心技术是我国测绘遥感领域首个实现核心技术出口的自主知识产权软件研发成果，授权许可给国际权威的地理信息研究和应用机构美国ESRI公司进行全球化推广应用，标志着我国测绘遥感领域的自主研发成果正式全面走向国际市场。",
        Image: []
      },
      {
        title: "",
        content: "",
        Image: []
      }
    ]
  },
  {
    id: 9,
    title: "全数字化摄影测量系统VirtuoZo",
    url: "https://dl.dpgrid.com/www/imgs/banner-13.jpg",
    Releasepeople: "武汉大学计算机视觉研究中心",
    keyword: "",
    content: "",
    time: "2009-06-05",
    introduce:
      "  VirtuoZo是由王之卓院士1978年提出，在张祖勋院士主持下经过十几年的努力研制成功的全数字化摄影测量系统。VirtuoZo采用国际先进的快速匹配算法确定同名点，可处理航空影像、SPOT 影像和近景影像。实现了从内定向、相对定向、空三、DEM生成、正射影像制作等生产过程的自动化。不但改变了我国传统的测绘模式，提高了生产效率，同时也为测绘部门拓展业务提供了强有力的工具，已广泛应用于国民经济建设各部门。项目在从实验室研究到产品化、产业化的过程中，先后获得了1989年国家教委科技进步一等奖、1993年国家自然科学二等奖、1997年国家测绘科技进步一等奖和1999年国家科技进步二等奖（推广类）。VirtuoZo全数字化摄影测量系统，以其世界领先的影像匹配技术、高效使用的系统功能被国际摄影测量界推崇为三大使用数字摄影测量系统之一，并已成为各行业生产空间地理数据4D产品的实用生产平台，实现了摄影测量事业的跨越式发展，产生经济效益逾亿元。"
  },
  {
    id: 10,
    title: "数字摄影测量网格（DPGrid）脱颖而出",
    url: "https://dl.dpgrid.com/www/imgs/banner-14.jpg",
    Releasepeople: "武汉大学计算机视觉研究中心",
    keyword: "",
    content: "",
    time: "2006-07-08",
    introduce: `数字摄影测量网格（Digital Thotogrammetry Grid--DPGrid）是由中国工程院院士、武汉大学教授张祖勋提出。DPGrid数字摄影测量网格系统打破传统的摄影测量流程，集生产、质量检测、管理为一体，合理地安排人、机的工作，充分应用当前先进的数字影像匹配、高性能并行计算、海量存储与网络通讯等技术，实现航空航天遥感数据的自动快速处理和空间信息的快速获取，其性能远远高于当前的数字摄影测量工作站，能够满足三维空间信息快速采集与更新的需要，实现为国民经济各部门与社会各方面提供具有很强现势性的三维空间信息。2007年7月12日，该产品通过国家鉴定，鉴定结论：“该系统研究思想新颖、研究成果先进，将为数字摄影测量的新一轮跨越式发展、为建立大规模的摄影测量数据处理中心和三线阵卫星影像的快速处理奠定基础。该系统整体上达到国际先进水平，其中数字摄影测量网格DPGrid并行处理技术、影像匹配技术和网络全无缝测图技术达到国际领先水平”。新一代航空航天数字摄影测量处理平台DPGrid，填补了我国数字摄影测量数据处理技术的空白，标志着我国数字摄影测量技术整体上达到国际先进水平。具有自主版权的高性能新一代航空航天数字摄影测量处理平台DPGrid，可以推广应用于国家基础测绘、城市基础地理信息动态更新、国土资源调查、生态环境监测、灾害监测、海洋资源、农业监测、快速响应等各个领域，大幅度地提高航空航天遥感影像数据处理的效率，缩短地图更新周期，提高空间信息获取的实时性，特别是对大型的自然灾害的快速评估、应急反映的方面，对于我国的社会经济发展以及军事安全等都具有重要的意义。`
  },
  {
    id: 11,
    title: "数字摄影测量与计算机视觉的异同点",
    url: "https://dl.dpgrid.com/www/imgs/banner-14.jpg",
    Releasepeople: "武汉大学计算机视觉研究中心",
    keyword: "",
    content: "",
    time: "2006-07-08",
    introduce:
      "数字摄影测量技术实际上就是测绘学科的一个分支，随着科学技术的进步，它已经渐渐地进入到计算机领域。计算机视觉技术主要是集数字图像处理、应用数学以及人工智能等学科知识于一体，它的应用很广泛比如计算机图像学、机器人学等领域。文中简要地介绍了计算机视觉技术的发展历程，分析和探讨了数字摄影测量与计算机视觉技术的异同点以及两者之间的联系。",
    content: [
      {
        title: "标签：数字摄影测量 计算机视觉 异同点 联系",
        content:
          "数字摄影测量总规是测绘学科的一个部分，它的主要原理就是利用摄影机摄取的影像，来测定物体在三维空间的信息。而计算机视觉主要就是研究计算机如何能够利用二维图像来获取三维环境中的信息，这项技术不仅仅能够对三维环境中物体的几何信息进行感知，包括物体的形状、位置、运动状态等，同时还能够对这些信息描述、存储以及识别。就研究的内容来看，计算机视觉与数字摄影测量是十分相近的，但是两者存在着本质的差异，文中主要论述了两者之间的关系。",
        Image: []
      },
      {
        title: "1计算机视觉的发展历程",
        content:
          "二十世纪六十年代统计模式识别的开始拉开了计算机视觉的序幕，当时的主要功能是对二维图像的分析与识别。六十年代Robert利用计算机程序从数字图像中提取出多面体的三维结构，同时对物体的形状以及空间关系进行了描述。到了七十年代，渐渐地出现了一些视觉应用系统。八十年代以来，计算机技术水平发生了质的发展，从而计算机视觉的研究被应用到实际中来，并且涉足更多复杂的视觉过程的研究。目前，计算机视觉技术的应用极为广泛，在许多领域中比如计算几何、图像处理等中都有计算机视觉技术的影子。计算机视觉的基础就是图像处理技术、信号处理技术、计算几何等学科知识，然后通过计算机分析以及处理视觉信息。如何模拟人类视觉功能就是计算机视觉的研究目标，是实现智能机器人的核心内容之一。计算机视觉作为一门比较综合性的学科，吸引了学多学科的研究者加入其中，包括计算机科学、信号处理以及物理学等等。近年来，计算机视觉技术与计算机图像学、数字摄影测量等学科之间有了千丝万缕的关系。",
        Image: []
      },
      {
        title: "2摄影测量",
        content:
          "摄影测量是指运用摄影机和胶片组合测量目标物的形状、大小和空间位置的技术，它利用光学摄影机获取的像片，经过处理以获取被摄物体的形状、大小、位置、特性及其相互关系。 关注的是几何量的量测信息（物体的位置、大小和形状等），主要任务是用于测绘各种比例尺的地形图、建立数字地面模型，为各种地理信息系统和土地信息系统提供基础数据。摄影测量学要解决的两大问题是几何定位和影像解译。几何定位就是确定被摄物体的大小、形状和空间位置。几何定位的基本原理源于测量学的前方交会方法，它是根据两个已知的摄影站点和两条已知的摄影方向线，交会出构成这两条摄影光线的待定地面点的三维坐标。影像解译就是确定影像对应地物的性质。当被测物体的尺寸或摄影距离小于100米时的摄影测量称之为近景摄影测量。随着数字传感器技术的发展，尤其是CCD器件和CMOS器件的迅速发展，利用CCD(或CMOS)像机不需要胶片就可直接获得被测物的数字影像，这种直接基于数字影像的近景摄影测量称为数字近景摄影测量。",
        Image: []
      },
      {
        title: "3计算机视觉测量",
        content:
          "计算机视觉是使用计算机及相关设备对生物视觉的一种模拟。主要 关注的是对物体进行描述、识别和理解，它的主要任务就是通过对采集的图片或视频进行处理以获得相应场景的三维信息，就像人类和许多其他类生物每天所做的那样。是一门关于如何运用照相机和计算机来获取我们所需的，被拍摄对象的数据与信息的学问。形象地说，就是给计算机安装上眼睛（照相机）和大脑（算法），让计算机能够感知环境。机器视觉系统是计算机学科的一个分支，是指通过机器视觉产品（即图像摄取装置，分CMOS和CCD两种）将被摄取目标转换成图像信号，传送给专用的图像处理系统，根据像素分布和亮度、颜色等信息，转变成数字化信号；图像系统对这些信号进行各种运算来抽取目标的特征，进而根据判别的结果来控制现场的设备动作。",
        Image: []
      },
      {
        title: "4计算机视觉与数字摄影测量的区别",
        content: "",
        Image: []
      },
      {
        title: "4.1两者的发展历史与目的不同",
        content:
          "计算机立体视觉诞生的标志就是美国的Robert把过去的二维图像分析引用到三维环境中；法国陆军上校劳赛达特在1851年提出的交会摄影测量一般被认为是交会摄影测量的起点。不论是计算机的发展还是计算机立体视觉的发展都要晚于摄影测量的发展。摄影测量始终都是测绘产业的重要组成部分之一，始终都是测绘学科的分支，主要就是利用摄影方式测绘，尤其是测绘地形图。所以，计算机视觉和摄影测量在目的方面有比较大的差异",
        Image: []
      },
      {
        title: "4.2出发点不同造成基本参数物理意义的不同",
        content:
          "计算机视觉是研究如何使机器人实现人的视觉，也就说模拟人的眼睛，以眼睛中心与光轴为基准坐标系，以空间坐标系相对于摄影机坐标系为平移量。然而摄影测量是测绘地形图的主要手段，统一以空间坐标系为基准，比如要对某一区域进行航空摄影测量，所有摄影机的空间位置以及影像的坐标都是相对于这个空间坐标系来定位的。所以，所谓摄影测量的外定向就是确定影像在此空间中相对于物体的位置与方位；而计算机视觉就是搜寻物体相对于影像的位置与方位。",
        Image: []
      },
      {
        title: "4.3研究方法的不同",
        content:
          "计算机视觉一般都是采用矩阵分解的办法确定线性方程直接解，尽量的把计算机视觉非线性问题转化为线性问题，避免求解非线性方程，因为非线性方程的解很复杂以及求解方法很麻烦，计算机视觉对于最小二乘法的应用很少。摄影测量主要是有观测值求解未知数，利用的是测量平方差。为此，如何确定函数模型、未知数处置的确定、解的稳定性以及精度与可靠性的评定等等是摄影测量所要考虑的。测绘学科数据处理的一般流程见图1。由此可见，两者对待同一问题的解决方式是不同的。最小二乘法被引用到数字摄影测量中之后，就会贯穿于整个数字摄影测量过程。而计算机立体视觉主要是利用计算机代替人眼识别影像。由此可见，两者的研究方法以及思考问题的方法都是不同的。",
        Image: []
      },
      {
        title: "5计算机视觉与数字摄影测量的联系",
        content:
          "计算机视觉与数字摄影测量两者研究的内容十分相近。如何利用二维图像信息推敲出三维环境信息是计算机视觉研究的目标，计算机视觉的重要组成部分就是双目立体视觉，它的目的就是利用二维投影图像如何恢复成三维景物世界，其原理主要就是模拟人类双眼处理景物的方式，原理简单实用而且可靠，在许多领域中都有很高的应用价值；数字摄影测量的发展离不开计算机视觉的研究成果，至摄影测量在数字测量中诞生以来，已经与计算机视觉紧密的联系在一起。测绘地形图的研究也正在以计算机为基础来采用立体视觉的原理，近日，科学家正在利用立体视觉原理探索如何利用同一地区的多张不同角度的照片来恢复地面的高度信息，以便能够真正的获得三维环境信息，并且这项研究已经取得了突破性的进展。计算机视觉的主要目标就是如何从二维影像中推敲出物体的三维运动以及形状，并且已经出现了许多种方法。主要就是要解决两个问题，一个是应对性问题以及给定对应时物体运动与形状的计算算法的问题。数字摄影测量与计算机视觉本质上是一样的，也是由两部分组成：一是不同影像上量测的同名点也就是计算机视觉中的对应性问题。传统的摄影测量主要是由双目望远镜系统来决定，在摄影测量过程中并不是主要的研究内容，在数字摄影测量中，它始终都是关注的焦点；二是影像与影像以及影像与空间的解析关系，这是摄影测量的最基本任务。",
        Image: []
      },
      {
        title: "6结语",
        content:
          "计算机视觉领域已经引用了数字摄影测量，随着科学技术水平的不断发展，数字摄影测量一定会以计算机视觉为观点出发。除此之外，虽然数字摄影测量与计算机视觉之间存在很大的差异，然而随着高精度量测型计算机视觉的需求以及数字摄影测量的发展，两者之间的学科交叉会越来越重要，或许会衍生出一门新的学科-----摄影测量计算机视觉。随着对计算机视觉以及数字摄影测量的不断研究，新的求解手段以及描述方式的出现，计算机视觉以及数字摄影测量必将迎来一个全新的时代。",
        Image: []
      },
      {
        title: "参考文献",
        content:
          "[1]查燕萍，张华平.數字摄影测量发展现状与趋势初探[J].江西测绘.2009（12）",
        Image: []
      },
      {
        title: "",
        content:
          "[2]张大春.数字地面摄影测量在工程勘测中的应用研究[D].西南交通大",
        Image: []
      },
      {
        title: "",
        content:
          "[3]彭树鸿，王闻宇，朱光珠.与计算机视觉相关的数字摄影测量的发展[J].西部资源.2012（10）.",
        Image: []
      }
    ]
  },
  {
    id: 12,
    title: "武汉大学数字摄影测量与计算机视觉研究中心揭牌 ",
    url: "https://dl.dpgrid.com/www/imgs/banner-16.jpg",
    Releasepeople: "武汉大学计算机视觉研究中心",
    keyword: "",
    content: "",
    time: "2004-11-23",
    introduce:
      "2004年11月由张祖勋院士创办，武汉大学数字摄影测量与计算机视觉研究中心揭牌，这意味着武汉大学数字摄影测量将与计算机视觉进行更深入、更广泛的探索；张院士指出，应发挥双方优势，将核心技术攻关和软件开发、社会服务独立分工，再以校企合作模式将学校科研成果服务于日常生活。当天，就该技术进行了深入交流，加强该领域基础研究、应用基础研究以及新技术、新产品的开发，并共同培养高层次专业技术人才。"
  },
  {
    id: 13,
    title: "数字摄影测量与计算机视觉 ",
    url: "https://dl.dpgrid.com/www/imgs/banner-19.jpg",
    Releasepeople: "",
    keyword: "数字摄影测量 计算机视觉 异同点 联系",
    content: "",
    time: "2004-11-23",
    introduce:
      "数字摄影测量技术实际上就是测绘学科的一个分支，随着科学技术的进步，它已经渐渐地进入到计算机领域。计算机视觉技术主要是集数字图像处理、应用数学以及人工智能等学科知识于一体，它的应用很广泛比如计算机图像学、机器人学等领域。文中简要地介绍了计算机视觉技术的发展历程，分析和探讨了数字摄影测量与计算机视觉技术的异同点以及两者之间的联系。",
    content: [
      {
        title: "标签：数字摄影测量 计算机视觉 异同点 联系",
        content:
          "数字摄影测量总规是测绘学科的一个部分，它的主要原理就是利用摄影机摄取的影像，来测定物体在三维空间的信息。而计算机视觉主要就是研究计算机如何能够利用二维图像来获取三维环境中的信息，这项技术不仅仅能够对三维环境中物体的几何信息进行感知，包括物体的形状、位置、运动状态等，同时还能够对这些信息描述、存储以及识别。就研究的内容来看，计算机视觉与数字摄影测量是十分相近的，但是两者存在着本质的差异，文中主要论述了两者之间的关系。",
        Image: []
      },
      {
        title: "1计算机视觉的发展历程",
        content:
          "二十世纪六十年代统计模式识别的开始拉开了计算机视觉的序幕，当时的主要功能是对二维图像的分析与识别。六十年代Robert利用计算机程序从数字图像中提取出多面体的三维结构，同时对物体的形状以及空间关系进行了描述。到了七十年代，渐渐地出现了一些视觉应用系统。八十年代以来，计算机技术水平发生了质的发展，从而计算机视觉的研究被应用到实际中来，并且涉足更多复杂的视觉过程的研究。目前，计算机视觉技术的应用极为广泛，在许多领域中比如计算几何、图像处理等中都有计算机视觉技术的影子计算机视觉的基础就是图像处理技术、信号处理技术、计算几何等学科知识，然后通过计算机分析以及处理视觉信息。如何模拟人类视觉功能就是计算机视觉的研究目标，是实现智能机器人的核心内容之一。计算机视觉作为一门比较综合性的学科，吸引了学多学科的研究者加入其中，包括计算机科学、信号处理以及物理学等等。近年来，计算机视觉技术与计算机图像学、数字摄影测量等学科之间有了千丝万缕的关系。",
        Image: []
      },
      {
        title: "2计算机视觉与数字摄影测量的区别",
        content: "",
        Image: []
      },
      {
        title: "2.1两者的发展历史与目的不同",
        content:
          "计算机立体视觉诞生的标志就是美国的Robert把过去的二维图像分析引用到三维环境中；法国陆军上校劳赛达特在1851年提出的交会摄影测量一般被认为是交会摄影测量的起点。不论是计算机的发展还是计算机立体视觉的发展都要晚于摄影测量的发展。摄影测量始终都是测绘产业的重要组成部分之一，始终都是测绘学科的分支，主要就是利用摄影方式测绘，尤其是测绘地形图。所以，计算机视觉和摄影测量在目的方面有比较大的差异。",
        Image: []
      },
      {
        title: "2.2出发点不同造成基本参数物理意义的不同",
        content:
          "计算机视觉是研究如何使机器人实现人的视觉，也就说模拟人的眼睛，以眼睛中心与光轴为基准坐标系，以空间坐标系相对于摄影机坐标系为平移量。然而摄影测量是测绘地形图的主要手段，统一以空间坐标系为基准，比如要对某一区域进行航空摄影测量，所有摄影机的空间位置以及影像的坐标都是相对于这个空间坐标系来定位的。所以，所谓摄影测量的外定向就是确定影像在此空间中相对于物体的位置与方位；而计算机视觉就是搜寻物体相对于影像的位置与方位。",
        Image: []
      },
      {
        title: "2.3研究方法的不同",
        content:
          "计算机视觉一般都是采用矩阵分解的办法确定线性方程直接解，尽量的把计算机视觉非线性问题转化为线性问题，避免求解非线性方程，因为非线性方程的解很复杂以及求解方法很麻烦，计算机视觉对于最小二乘法的应用很少。摄影测量主要是有观测值求解未知数，利用的是测量平方差。为此，如何确定函数模型、未知数处置的确定、解的稳定性以及精度与可靠性的评定等等是摄影测量所要考虑的。测绘学科数据处理的一般流程见图1。",
        Image: []
      },
      {
        title: "3计算机视觉与数字摄影测量的联系",
        content:
          "计算机视觉与数字摄影测量两者研究的内容十分相近。如何利用二维图像信息推敲出三维环境信息是计算机视觉研究的目标，计算机视觉的重要组成部分就是双目立体视觉，它的目的就是利用二维投影图像如何恢复成三维景物世界，其原理主要就是模拟人类双眼处理景物的方式，原理简单实用而且可靠，在许多领域中都有很高的应用价值；数字摄影测量的发展离不开计算机视觉的研究成果，至摄影测量在数字测量中诞生以来，已经与计算机视觉紧密的联系在一起。测绘地形图的研究也正在以计算机为基础来采用立体视觉的原理，近日，科学家正在利用立体视觉原理探索如何利用同一地区的多张不同角度的照片来恢复地面的高度信息，以便能够真正的获得三维环境信息，并且这项研究已经取得了突破性的进展。计算机视觉的主要目标就是如何从二维影像中推敲出物体的三维运动以及形状，并且已经出现了许多种方法。主要就是要解决两个问题，一个是应对性问题以及给定对应时物体运动与形状的计算算法的问题。数字摄影测量与计算机视觉本质上是一样的，也是由两部分组成：一是不同影像上量测的同名点也就是计算机视觉中的对应性问题。传统的摄影测量主要是由双目望远镜系统来决定，在摄影测量过程中并不是主要的研究内容，在数字摄影测量中，它始终都是关注的焦点；二是影像与影像以及影像与空间的解析关系，这是摄影测量的最基本任务。",
        Image: []
      },
      {
        title: "4结语",
        content:
          "计算机视觉领域已经引用了数字摄影测量，随着科学技术水平的不断发展，数字摄影测量一定会以计算机视觉为观点出发。除此之外，虽然数字摄影测量与计算机视觉之间存在很大的差异，然而随着高精度量测型计算机视觉的需求以及数字摄影测量的发展，两者之间的学科交叉会越来越重要，或许会衍生出一门新的学科-----摄影测量计算机视觉。随着对计算机视觉以及数字摄影测量的不断研究，新的求解手段以及描述方式的出现，计算机视觉以及数字摄影测量必将迎来一个全新的时",
        Image: []
      },
      {
        title: "参考文献",
        content:
          "[1]查燕萍，张华平.數字摄影测量发展现状与趋势初探[J].江西测绘.2009（12）.",
        Image: []
      },
      {
        title: "",
        content:
          "[2]张大春.数字地面摄影测量在工程勘测中的应用研究[D].西南交通大学.2012年.",
        Image: []
      },
      {
        title: "",
        content:
          "[3]彭树鸿，王闻宇，朱光珠.与计算机视觉相关的数字摄影测量的发展[J].西部资源.2012（10）.",
        Image: []
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/assets/information.js